module.exports = __webpack_public_path__ + "static/media/container.c88d2e06.jpg";